import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class ExceptionTypeService {

    private availabilityChange: BehaviorSubject<AvailabilityChange> = new BehaviorSubject<AvailabilityChange>({
        id: '',
        available: false
    });

    private _availableConditionsTotal = new Map<string, number>();

    public updateAvailability(kind: string, available: boolean) {
        this.availabilityChange.next({
            id: kind,
            available: available
        });
    }

    public observeAvailabilityChanges(): Observable<AvailabilityChange> {
        return this.availabilityChange.asObservable();
    }

    public getAvailableConditionsTotal(kind: string): number {
        return this._availableConditionsTotal.get(kind);
    }

    public updateAvailableConditionsTotal(kind: string, count: number) {
        this._availableConditionsTotal.set(kind, count);
    }
}

export interface AvailabilityChange {
    id: string;
    available: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exception-type.service.ts